import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massRestoreServices } from "../../api/apiServices";
import parseError from "../../utils/parseError";

/**
 * Hook لاستعادة جماعية للخدمات
 */
export function useRestoreAllServices() {
    const queryClient = useQueryClient();

    const {
        mutate: restoreAllServicesMutate,
        isPending,
    } = useMutation({
        mutationFn: massRestoreServices,
        onSuccess: (response) => {
            toast.success(response.message || "Restored successfully");
            queryClient.invalidateQueries({ queryKey: ["services"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to restore services");
        },
    });

    return {
        restoreAllServicesMutate,
        isPending,
    };
}